import { institusjonNavnKort } from "./initialState";

export const isUdirTenant = institusjonNavnKort.toLowerCase() === "udir";